module.exports = __webpack_public_path__ + "static/media/b_size_3.5edff62d.jpg";